import { jsx as _jsx } from "react/jsx-runtime";
import { RecipeDetailsType } from '@planter/common';
import * as React from 'react';
import { UserRole } from '../models/general.models';
import RouteAuthorizer from './components/RouteAuthorizer';
import { AppRoutes } from './routes';
var PlanPage = React.lazy(function () { return import('../pages/plan/plan.page'); });
var RecipePage = React.lazy(function () { return import('../pages/recipeDetails/recipe.page'); });
var MealPrepPage = React.lazy(function () { return import('../pages/mealPrep/mealPrep.page'); });
var planRedirectPages = [
    {
        userRole: UserRole.Anonymous,
        page: AppRoutes.Intro,
    },
    {
        userRole: UserRole.NoCountryUser,
        page: AppRoutes.Intro,
    },
    {
        userRole: UserRole.PartialUser,
        page: AppRoutes.JoinFamily,
    },
    {
        userRole: UserRole.PlanPendingUser,
        page: AppRoutes.OnboardingWelcomePage,
    },
    {
        userRole: UserRole.UserPaymentNeeded,
        page: AppRoutes.SubscriptionPage,
    },
];
var planRoutes = [
    {
        path: AppRoutes.Plan,
        element: (_jsx(RouteAuthorizer, { userRoles: [UserRole.CompleteUser], redirectPages: planRedirectPages, children: _jsx(PlanPage, {}) })),
    },
    {
        path: AppRoutes.PlanRecipe,
        element: (_jsx(RouteAuthorizer, { userRoles: [UserRole.CompleteUser], redirectPages: planRedirectPages, children: _jsx(RecipePage, { type: RecipeDetailsType.Plan }) })),
    },
    {
        path: AppRoutes.MealPrep,
        element: (_jsx(RouteAuthorizer, { userRoles: [UserRole.CompleteUser], redirectPages: planRedirectPages, children: _jsx(MealPrepPage, {}) })),
    },
];
export default planRoutes;
